import { FC } from 'react';

import { HowDoesItWorkSection } from '@/components/HowDoesItWorkSection';
import type {
  HowDoesItWork,
  PredefinedBlock as BlockType,
  TestimonialItem,
} from '@/interfaces/cms';
import LandingFAQ from '@/pages/Landing/components/LandingFAQ';
import { LandingFindMyPlan } from '@/pages/Landing/components/LandingFindMyPlan';
import LandingGetMoreSection from '@/pages/Landing/components/LandingGetMoreSection/LandingGetMoreSection';
import LandingTestimonials from '@/pages/Landing/components/LandingTestimonials';

type Props = {
  block: BlockType;
  testimonials: TestimonialItem[];
  howDoesItWork: HowDoesItWork | null;
};

export const PredefinedBlock: FC<Props> = ({
  block,
  testimonials,
  howDoesItWork,
}) => {
  switch (block.type) {
    case 'find-my-plan': {
      return <LandingFindMyPlan />;
    }
    case 'features': {
      return <LandingGetMoreSection />;
    }
    case 'faqs': {
      return <LandingFAQ />;
    }
    case 'how-does-it-work': {
      if (!(howDoesItWork && howDoesItWork.enabled)) {
        return null;
      }

      return <HowDoesItWorkSection content={howDoesItWork} />;
    }
    case 'testimonials': {
      if (!testimonials.length) return null;

      return <LandingTestimonials testimonialsArray={testimonials} />;
    }

    default:
      return null;
  }
};
